import { render, staticRenderFns } from "./MatrixReportTable.vue?vue&type=template&id=3ebe343b"
import script from "./MatrixReportTable.vue?vue&type=script&lang=js"
export * from "./MatrixReportTable.vue?vue&type=script&lang=js"
import style0 from "./MatrixReportTable.vue?vue&type=style&index=0&id=3ebe343b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports